import events from './events';
import placements from './placements';
import infoBehaviourOnHover from './infoBehaviourOnHover';
import scrollAnimations from './scrollAnimations';
import infoType from './infoType';
import loadingMode from './loadingMode';
import textBoxHeightCalculationOptions from './textBoxHeightCalculationOptions';
import textBoxWidthCalculationOptions from './textBoxWidthCalculationOptions';
import overlayAnimations from './overlayAnimations';
import imageHoverAnimations from './imageHoverAnimations';
import layout from './layout';
import cubeType from './cubeType';
import itemClick from './itemClick';
import scrollDirection from './scrollDirection';
import thumbnailsAlignment from './thumbnailsAlignment';
import watermarkDock from './watermarkDock';
import loadMoreAmount from './loadMoreAmount';
import expandAnimations from './expandAnimations';
import horizontalAlign from './horizontalAlign';
import verticalAlign from './verticalAlign';
import videoPlay from './videoPlay';
import groupTypes from './groupTypes';
import mobileSwipeAnimations from './mobileSwipeAnimations';
import expandInfoPositions from './expandInfoPositions';
import dimensions from './dimensions';
import gallerySizeType from './gallerySizeType';
import isVertical from './isVertical';
import galleryTextAlign from './galleryTextAlign.js';
import gridStyle from './gridStyle';
import layoutDirection from './layoutDirection';
import arrowsPosition from './arrowsPosition';
export default {
  events: events,
  placements: placements,
  infoBehaviourOnHover: infoBehaviourOnHover,
  scrollAnimations: scrollAnimations,
  infoType: infoType,
  loadingMode: loadingMode,
  layout: layout,
  itemClick: itemClick,
  textBoxHeightCalculationOptions: textBoxHeightCalculationOptions,
  textBoxWidthCalculationOptions: textBoxWidthCalculationOptions,
  scrollDirection: scrollDirection,
  cubeType: cubeType,
  thumbnailsAlignment: thumbnailsAlignment,
  watermarkDock: watermarkDock,
  loadMoreAmount: loadMoreAmount,
  expandAnimations: expandAnimations,
  overlayAnimations: overlayAnimations,
  imageHoverAnimations: imageHoverAnimations,
  horizontalAlign: horizontalAlign,
  verticalAlign: verticalAlign,
  videoPlay: videoPlay,
  groupTypes: groupTypes,
  mobileSwipeAnimations: mobileSwipeAnimations,
  expandInfoPositions: expandInfoPositions,
  dimensions: dimensions,
  gallerySizeType: gallerySizeType,
  isVertical: isVertical,
  galleryTextAlign: galleryTextAlign,
  gridStyle: gridStyle,
  layoutDirection: layoutDirection,
  arrowsPosition: arrowsPosition
};